// Paso 4 del asistente (PE-A3b): resultados. Resumen por estado arriba; luego los no cumple (norma, artículo,
// umbral y valor), los por validar (qué falta y en qué paso, con enlace) y los sectores ordenados por Qs con el
// nivel del RD 164 y la clasificación del AM 1257 Art. 139 (PE-29 abierto: solo se ordena y se muestra).

import React from 'react';
import type { SectorEnPantalla } from '../../lib/pe/pe-paso2';
import type { Evaluacion } from '../../lib/pe/pe-paso3';
import { conteo, ORDEN_ESTADOS, sectoresPorQs, SEMAFORO, todasLasTrazas } from '../../lib/pe/pe-resultados';
import { formatoEc } from '../../lib/pe/pe-unidades';
import { Semaforo, TrazaItem } from './ComponentesPE';

const ART139: Record<string, string> = { leve: 'Leve', ordinario: 'Ordinario', extra: 'Extra' };

export default function Paso4Resultados({ evaluaciones, sectores, irAPaso, meseriAnteriores = 0, destino }: {
  evaluaciones: Evaluacion[]; sectores: SectorEnPantalla[]; irAPaso: (p: number, claveEvaluacion?: string) => void;
  destino?: (p: number, claveEvaluacion?: string) => string;  // PE-C1: nombre del capítulo donde se completa
  meseriAnteriores?: number; // filas MESERI de grupos anteriores sin limpiar (no se cuentan)
}) {
  const s = sectoresPorQs(sectores);
  const trazas = todasLasTrazas(evaluaciones, s.trazas);
  const c = conteo(trazas);
  const de = (estado: 'no_cumple' | 'por_validar' | 'cumple' | 'informativo') => trazas.filter(t => t.estado === estado);
  return (
    <div className="pe2-columna">
      {meseriAnteriores > 0 && (
        <p className="pe2-nota" role="note" style={{ margin: 0 }}>
          Hay evaluaciones de grupos anteriores; un administrador las limpiará al guardar.
        </p>
      )}
      <section className="pe2-card" aria-label="Resumen">
        <h3>Resumen</h3>
        <div className="pe2-resumen">
          {ORDEN_ESTADOS.map(e => (
            <div key={e} className="pe2-resumen-celda" style={{ borderColor: SEMAFORO[e].color }}>
              <Semaforo estado={e} /><b>{c[e]}</b>
            </div>
          ))}
        </div>
      </section>

      <section className="pe2-card" aria-label="Sectores por carga de fuego">
        <h3>Sectores por carga de fuego (Qs)</h3>
        <p className="pe2-nota" style={{ margin: 0 }}>Ordenados de mayor a menor Qs. La jerarquización está por validar.</p>
        {s.filas.length === 0 && <p className="pe2-nota">Aún no hay sectores (capítulo 2).</p>}
        <div className="pe2-tarjetas">
          {s.filas.map(f => (
            <div key={f.nombre} className="pe2-tarjeta">
              <b>{f.nombre}</b>
              {f.error ? <span className="pe2-error-texto">No se puede calcular: {f.error}</span> : (
                <>
                  <span>Qs {formatoEc(f.qsMJm2, 1)} MJ/m²</span>
                  <span>RD 164: nivel {f.nivel} ({f.categoria})</span>
                  <span>AM 1257, Art. 139: {ART139[f.art139] ?? f.art139}</span>
                </>
              )}
            </div>
          ))}
        </div>
      </section>

      <section className="pe2-card" aria-label="No cumple">
        <h3>No cumple ({c.no_cumple})</h3>
        {de('no_cumple').length === 0 ? <p className="pe2-nota">Ningún incumplimiento.</p>
          : de('no_cumple').map((t, i) => <TrazaItem key={i} t={t} origen={t.evaluacion} irAPaso={irAPaso} claveEvaluacion={t.claveEvaluacion} destino={destino} />)}
        {c.no_cumple > 0 && <div className="pe2-acciones"><button type="button" className="pe2-btn" onClick={() => irAPaso(5)}>Ver el plan de acción</button></div>}
      </section>

      <section className="pe2-card" aria-label="Por validar">
        <h3>Por validar ({c.por_validar})</h3>
        {de('por_validar').length === 0 ? <p className="pe2-nota">Nada pendiente.</p>
          : de('por_validar').map((t, i) => <TrazaItem key={i} t={t} origen={t.evaluacion} irAPaso={irAPaso} claveEvaluacion={t.claveEvaluacion} destino={destino} />)}
      </section>

      <details className="pe2-card">
        <summary>Cumple ({c.cumple}) e informativos ({c.informativo})</summary>
        <div className="pe2-lista-trazas">
          {de('cumple').concat(de('informativo')).map((t, i) => <TrazaItem key={i} t={t} origen={t.evaluacion} />)}
        </div>
      </details>
    </div>
  );
}
